// Mock data for GameOS platform

// Example games that can be generated with GameOS - ALL are playable demos!
export const featuredGames = [
  {
    id: 1,
    title: "3D Neon Racer",
    tags: ["3D", "Racing", "WebGL"],
    description: "A true 3D WebGL racing demo with a neon highway, parallax cityscape, and responsive car controls.",
    gradient: "from-purple-900 via-pink-900 to-red-900",
    icon: "🏎️",
    gameUrl: "/games/3d-racer.html",
    playable: true
  },
  {
    id: 2,
    title: "Arena FPS Demo",
    tags: ["3D", "FPS", "WebGL"],
    description: "First-person WebGL arena with WASD movement, mouse-look, and neon pillar targets to shoot.",
    gradient: "from-red-900 via-orange-900 to-yellow-900",
    icon: "🎯",
    gameUrl: "/games/fps-demo.html",
    playable: true
  },
  {
    id: 3,
    title: "RPG Legends Demo",
    tags: ["RPG", "Adventure", "Quest"],
    description: "Top-down RPG slice with dialogue, quest stages, combat, XP, and gold.",
    gradient: "from-green-900 via-emerald-900 to-teal-900",
    icon: "⚔️",
    gameUrl: "/games/rpg-demo.html",
    playable: true
  },
  {
    id: 4,
    title: "Space Defender",
    tags: ["Arcade", "Shooter", "Sci-Fi"],
    description: "Defend Earth from alien invaders! Move with arrow keys, space to shoot. Fast-paced arcade action.",
    gradient: "from-blue-900 via-purple-900 to-indigo-900",
    icon: "🚀",
    gameUrl: "/games/space-defender.html",
    playable: true
  },
  {
    id: 5,
    title: "Pixel Knight Quest",
    tags: ["Action", "Platformer", "Adventure"],
    description: "Jump across platforms and collect coins while avoiding enemies. Classic platformer action!",
    gradient: "from-orange-800 via-red-800 to-purple-900",
    icon: "⚔️",
    gameUrl: "/games/pixel-knight.html",
    playable: true
  },
  // Color Match Puzzle demo removed from showcase

  {
    id: 7,
    title: "Endless Runner City",
    tags: ["Arcade", "Runner", "Urban"],
    description: "Jump and slide through obstacles in this infinite runner. How far can you go?",
    gradient: "from-cyan-700 via-teal-800 to-blue-900",
    icon: "🏃",
    gameUrl: "/games/endless-runner.html",
    playable: true
  },
  // Bubble Pop Adventure demo removed from showcase

  {
    id: 9,
    title: "Maze Escape",
    tags: ["Puzzle", "Strategy", "Adventure"],
    description: "Navigate procedurally generated mazes. Find the exit and advance through levels!",
    gradient: "from-green-800 via-emerald-800 to-teal-900",
    icon: "🧩",
    gameUrl: "/games/maze-escape.html",
    playable: true
  },
  // Memory Card Game demo removed from showcase

  {
    id: 11,
    title: "Snake Evolution",
    tags: ["Arcade", "Classic", "Casual"],
    description: "Classic snake game with smooth controls. Eat food to grow longer and score points!",
    gradient: "from-lime-700 via-green-700 to-emerald-800",
    icon: "🐍",
    gameUrl: "/games/snake-evolution.html",
    playable: true
  }
];

export const assetCategories = [
  {
    id: 1,
    name: "Animation",
    gradient: "from-blue-900 via-purple-900 to-indigo-900",
    icon: "🎬"
  },
  {
    id: 2,
    name: "VFX",
    gradients: [
      { gradient: "from-orange-700 via-red-700 to-pink-700", icon: "💥" },
      { gradient: "from-purple-700 via-violet-700 to-fuchsia-700", icon: "✨" },
      { gradient: "from-cyan-700 via-blue-700 to-indigo-700", icon: "⚡" }
    ]
  },
  {
    id: 3,
    name: "Roles",
    gradients: [
      { gradient: "from-green-700 via-emerald-700 to-teal-700", icon: "🦸" },
      { gradient: "from-red-800 via-rose-800 to-pink-800", icon: "👾" },
      { gradient: "from-amber-700 via-yellow-700 to-orange-700", icon: "🧙" }
    ]
  },
  {
    id: 4,
    name: "Tileset",
    gradient: "from-slate-700 via-gray-700 to-zinc-700",
    icon: "🎨"
  }
];

export const environmentThemes = [
  { name: "Frozen Winter", color: "#7DD3FC" },
  { name: "Blossom Spring", color: "#FCA5A5" },
  { name: "Golden Summer", color: "#FDE047" },
  { name: "Crimson Autumn", color: "#FB923C" }
];

export const audioTypes = [
  { name: "Player Jumping", category: "Sound Effect" },
  { name: "Player losing or failing", category: "Sound Effect" },
  { name: "Magic sweep game trophy", category: "Sound Effect" },
  { name: "Game bonus reached", category: "Sound Effect" }
];

export const faqData = [
  {
    id: 1,
    question: "What is GameOS?",
    answer: "GameOS is the world's first game vibe coding agent that allows you to create complete, playable games using just text prompts. Our AI-powered platform generates game logic, assets, and mechanics automatically."
  },
  {
    id: 2,
    question: "What is GameOS's goal?",
    answer: "Our goal is to democratize game development, making it accessible to everyone regardless of coding experience. We want to empower creators to build games that generate revenue from day one."
  },
  {
    id: 3,
    question: "How do I activate GameOS?",
    answer: "Simply sign up for a free account, describe your game idea in natural language, and watch as GameOS generates your game in real-time. You can iterate and refine using additional prompts."
  },
  {
    id: 4,
    question: "Do I need game development experience to use GameOS?",
    answer: "No! GameOS is designed for everyone, from complete beginners to experienced developers. Our vibe coding engine understands natural language and handles all the technical complexity for you."
  },
  {
    id: 5,
    question: "How does monetization work with GameOS?",
    answer: "GameOS includes built-in ad network integration. You can insert ads into your game with a single prompt, enabling you to generate revenue from the moment your first player starts playing."
  },
  {
    id: 6,
    question: "Which AI models can I use?",
    answer: "GameOS gives you the full Universal roster — 55 models across OpenAI, Anthropic and Google, including the new GPT-6 Astra flagship, Claude Fable 5.1, Claude Opus 5 and Gemini 3.8 Flash. Pick a different brain for every build or refinement."
  },
  {
    id: 7,
    question: "Can GameOS build 3D games?",
    answer: "Yes — the upgraded engine produces cinematic WebGL 3D games with realistic lighting, soft shadows, fog and tone-mapped color, plus multi-level 2D games. Just describe the vibe and the AI does the rest."
  },
  {
    id: 8,
    question: "Can people play my games on mobile?",
    answer: "Absolutely. Every shared game ships with an on-screen virtual gamepad on phones and tablets, so your players get full controls on any device."
  },
  {
    id: 9,
    question: "What is remixing?",
    answer: "Any public game page has a 'Remix with AI' button. Clicking it forks that game into your own AI session — for free — so you can build your own spin on it."
  }
];